<template>
  <q-select
    v-model.lazy="selectedBroker"
    :options="optionBrokers"
    use-input
    clearable
    dense
    behavior="box"
    fill-input
    input-debounce="0"
    option-value="broker_no"
    option-label="broker_name"
    emit-value
    stack-label
    map-options
    :label="filterName"
    filter
    @filter="filterBrokers"
    style="width: 130px; padding-left: 5px"
  >
    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps">
        <q-item-section avatar>
          <q-item-label class="text-bold">{{
            scope.opt.broker_no
          }}</q-item-label>
        </q-item-section>

        <q-item-section>
          <q-item-label>
            <div class="row">
              {{ scope.opt.broker_name }}
            </div>
          </q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey"> No results </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import useData from "src/use/data";

const emit = defineEmits(["emitedeBroker"]);

const props = defineProps({
  filterName: {
    type: String,
    default: "Filter Broker",
  },
});

const { brokerList } = useData();

const selectedBroker = ref("");
const optionBrokers = ref([]);
const brokerLists = ref([]);

const filterBrokers = (val, update) => {
  if (val === "") {
    update(() => {
      optionBrokers.value = brokerLists.value;
    });
    return;
  }

  update(() => {
    const needle = val;
    optionBrokers.value = brokerLists.value.filter((v) => {
      return (
        v.broker_name.toLowerCase().indexOf(needle) > -1 ||
        v.broker_no.toString().toLowerCase().indexOf(needle) > -1
      );
    });
  });
};

watch(selectedBroker, (newVal) => emit("emitedeBroker", newVal ?? ""));

onMounted(async () => {
  brokerList().then((res) => {
    brokerLists.value = res.data;
  });
});
</script>
